// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"d38d7399","140":"77a36e4c","563":"a2796189"}[chunkId] + ".chunk.js";
};